import {useCallback, useState} from 'react'

// convenience wrapper for useState, which provides a dirty boolean to track
// when the initial state has changed
export const useStateChanged = <T extends object | string | number | boolean>(
  initial: T | (() => T)
) => {
  const [initialState] = useState(initial)
  const [{changed, val}, setState] = useState<{changed: boolean; val: T}>({
    changed: false,
    val: initialState
  })

  // const [changed, setChanged] = useState(false)
  const wrappedSetVal = useCallback(
    (setter: React.SetStateAction<T>) => {
      return setState(current => ({
        changed: true,
        val: typeof setter === 'function' ? setter(current.val) : setter
      }))
    },
    [setState]
  )
  const reset = useCallback(
    (setter?: React.SetStateAction<T>) => {
      return setState(current => ({
        changed: false,
        val: setter
          ? typeof setter === 'function'
            ? setter(current.val)
            : setter
          : initialState
      }))
    },
    [initialState]
  )

  return [val, wrappedSetVal, changed, reset] as const
}
